import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";
import PageShell, { PageHero } from "../v2/pages/PageShell";
import { Arrow } from "../v2/components/Primitives";
import { pickLang } from "../v2/copy";
import { route } from "../v2/paths";

const NotFound: React.FC = () => {
  const { currentLanguage, t } = useTranslation();
  const navigate = useNavigate();
  const lang = pickLang(currentLanguage);
  const isFr = lang === "fr";

  const tr = (key: string, fallback: string) => {
    const value = t(key);
    return value && value !== key ? value : fallback;
  };

  const title = tr("notFound.title", isFr ? "Page introuvable" : "Page not found");
  const subtitle = tr(
    "notFound.subtitle",
    isFr
      ? "La page que vous cherchez n’existe pas ou a été déplacée."
      : "The page you are looking for doesn’t exist or has been moved.",
  );

  return (
    <PageShell seo={{ title: `${title} | Lave Tes Baskets`, description: subtitle, canonicalPath: route(lang), noindex: true }}>
      <PageHero
        crumbs={[{ label: isFr ? "Accueil" : "Home", to: route(lang) }, { label: "404" }]}
        index="404"
        eyebrow={isFr ? "Erreur" : "Error"}
        title={
          isFr ? (
            <>
              Cette page a <em className="italic text-tangerine">disparu.</em>
            </>
          ) : (
            <>
              This page has <em className="italic text-tangerine">vanished.</em>
            </>
          )
        }
        lede={subtitle}
        actions={
          <>
            <Link to={route(lang)} className="v2-btn v2-btn-solid">
              {tr("notFound.home", isFr ? "Retour à l’accueil" : "Back to home")}
              <Arrow />
            </Link>
            <button type="button" onClick={() => navigate(-1)} className="v2-btn v2-btn-ghost">
              {tr("notFound.back", isFr ? "Revenir en arrière" : "Go back")}
            </button>
          </>
        }
        aside={
          <img
            src="/illustrations/landing/404.webp"
            alt=""
            loading="lazy"
            className="ml-auto max-h-[420px] w-auto max-w-full object-contain opacity-80"
            onError={(e) => {
              const el = e.currentTarget;
              if (!el.src.endsWith("/composer.webp")) el.src = "/illustrations/landing/composer.webp";
            }}
          />
        }
      />
    </PageShell>
  );
};

export default NotFound;
